<template>
    <portal>
        <div class="mb-8 d-flex align-center">
            <v-icon color="primary" size="30">mdi-newspaper</v-icon>
            <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Newsletters</h1>
        </div>

        <v-row class="pa-4">
            <v-switch v-model="subscribed" label="Subscribed to newsletters" @change="updateSubscription"></v-switch>
        </v-row>

        <v-data-table
            class="portal--table"
            :items="newsletters"
            :headers="headers"
            :hide-default-footer="true">
            <template #item.link="{item}">
                <a :href="item.file_url" download target="_blank">
                    <v-icon>mdi-download</v-icon>
                </a>
            </template>
        </v-data-table>

        <v-dialog v-model="modal">
            <div v-if="selectedNewsletter">
                <h2 style="background: lightgray; text-align: center;">{{ selectedNewsletter.title }} ({{ selectedNewsletter.publish_date}})</h2>
                <iframe
                    :src="selectedNewsletter.file_url" style="width:1500px; height: 1200px;"></iframe>
            </div>
        </v-dialog>
    </portal>
</template>

<script>
import axios from "axios";
import {mapState, mapActions} from "vuex";
import Portal from "@/components/Portal";

export default {
    components: {
        Portal,
    },

    computed: {
        ...mapState('auth', ['user']),
    },

    data() {
        return {
            newsletters: [],
            modal: false,
            selectedNewsletter: null,
            subscribed: false,
            headers: [
                {text: 'Title', value: 'title'},
                {text: 'Publish Date', value: 'publish_date'},
                {text: 'Link', value: 'link'}
            ]
        }
    },

    mounted() {
        axios.get('api/client/'  + this.user.id + '/newsletters').then(({data}) => {
            this.newsletters = data;
        });
        this.subscribed = this.user.newsletter_subscribed;
    },

    methods: {
        ...mapActions('auth', ['updateUserData']),

        updateSubscription() {
            this.updateUserData({newsletter_subscribed: this.subscribed})
        }
    }
}
</script>
